import { Button, Link } from '@sequencehq/core-components'
import { invoicePaths } from 'Invoices/invoices.router'

export const ViewInvoiceButton = (props: {
  invoiceId: string
  fullWidth?: boolean
  'data-testid'?: string
}) => {
  return (
    <Button
      as={Link.Unstyled}
      to={invoicePaths.edit(props.invoiceId)}
      target="_blank"
      rel="noopener noreferrer"
      variant="secondary"
      fullWidth={props.fullWidth}
      data-testid={props['data-testid']}
    >
      View invoice
    </Button>
  )
}
